var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "support",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M11,1A10,10,0,1,0,21,11,10.012,10.012,0,0,0,11,1Zm8.3,6.112L15.825,8.551A5.448,5.448,0,0,0,13.45,6.175L14.889,2.7A9.223,9.223,0,0,1,19.3,7.112ZM11,15.583A4.583,4.583,0,1,1,15.583,11,4.589,4.589,0,0,1,11,15.583Zm3.119-13.2L12.68,5.853a5.364,5.364,0,0,0-3.361,0L7.881,2.38a9.165,9.165,0,0,1,6.238,0ZM7.112,2.7,8.551,6.175A5.446,5.446,0,0,0,6.175,8.55L2.7,7.111A9.223,9.223,0,0,1,7.112,2.7ZM2.38,7.881,5.853,9.32a5.364,5.364,0,0,0,0,3.361L2.38,14.119a9.165,9.165,0,0,1,0-6.238ZM2.7,14.888l3.474-1.439A5.448,5.448,0,0,0,8.55,15.825L7.111,19.3A9.223,9.223,0,0,1,2.7,14.888Zm5.18,4.731L9.32,16.147a5.364,5.364,0,0,0,3.361,0l1.439,3.473a9.165,9.165,0,0,1-6.238,0Zm7.008-.321-1.439-3.474a5.448,5.448,0,0,0,2.375-2.375L19.3,14.889A9.223,9.223,0,0,1,14.888,19.3Zm4.731-5.18L16.147,12.68a5.364,5.364,0,0,0,0-3.361L19.62,7.881a9.165,9.165,0,0,1,0,6.238Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.ea7ecb8df8efe93be8b9903b8ed5895d.svg";
export { ForwardRef as ReactComponent };